import { Typography, Button } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';

interface AddNewCopyProps {
  onAddNewCopy: (index: number) => void;
  index: number;
}

export default function AddNewCopy({ onAddNewCopy, index }: AddNewCopyProps) {
  return (
    <Button
      onClick={() => onAddNewCopy(index)}
      sx={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}
    >
      <AddIcon sx={{ marginRight: '8px' }} />
      <Typography color="#447EEB" fontWeight={700} fontSize="14px">
        Add New Copy
      </Typography>
    </Button>
  );
}
